<template>
  <b-sidebar id="sidebar-chat"  right shadow width="343px" :visible="chat"  backdrop no-header  z-index="2" @hidden="closeMe" >
   <div class="chat">
         <div class="header__chat d-flex justify-content-between align-items-center">
            <div class="user d-flex  align-items-center">
                <img :src="require('@/assets/logo.png')" alt="">
                <h3>Erlando</h3>
            </div>
            <div class="close-icon" @click="closeMe">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#474D52"/>
                </svg>
            </div>
        </div>
        <div class="body__chat">
            <div class="" v-for="(chat, i) in chats" :key="i" >
                <div class="msg-header d-flex align-items-center" :class="{'received': chat.type==0, 'send': chat.type==1}" v-if="chat.header">
                <h4 class="mr-2" v-if="chat.type==0">Erlando</h4>
                <h4 class="mr-2" v-else>You</h4>
                <h5 class="mr-2"> 10:30 AM</h5>
                </div>
                <div class="msg" :class="{'received': chat.type==0, 'send': chat.type==1, 'encryption': chat.encryption}">
                    <p>{{chat.msg}}</p>
                    <svg v-if="chat.encryption && chat.type==1" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.91699 7.49998C2.59483 7.49998 2.33366 7.76115 2.33366 8.08331V12.1666C2.33366 12.4888 2.59483 12.75 2.91699 12.75H11.0837C11.4058 12.75 11.667 12.4888 11.667 12.1666V8.08331C11.667 7.76115 11.4058 7.49998 11.0837 7.49998H2.91699ZM1.16699 8.08331C1.16699 7.11681 1.95049 6.33331 2.91699 6.33331H11.0837C12.0502 6.33331 12.8337 7.11681 12.8337 8.08331V12.1666C12.8337 13.1331 12.0502 13.9166 11.0837 13.9166H2.91699C1.95049 13.9166 1.16699 13.1331 1.16699 12.1666V8.08331Z" fill="#8D99A0"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 2.24998C6.38116 2.24998 5.78767 2.49581 5.35008 2.9334C4.9125 3.37098 4.66667 3.96447 4.66667 4.58331V6.91665C4.66667 7.23881 4.4055 7.49998 4.08333 7.49998C3.76117 7.49998 3.5 7.23881 3.5 6.91665V4.58331C3.5 3.65506 3.86875 2.76482 4.52513 2.10844C5.1815 1.45206 6.07174 1.08331 7 1.08331C7.92826 1.08331 8.8185 1.45206 9.47487 2.10844C10.1313 2.76482 10.5 3.65506 10.5 4.58331V6.91665C10.5 7.23881 10.2388 7.49998 9.91667 7.49998C9.5945 7.49998 9.33333 7.23881 9.33333 6.91665V4.58331C9.33333 3.96447 9.0875 3.37098 8.64992 2.9334C8.21233 2.49581 7.61884 2.24998 7 2.24998Z" fill="#8D99A0"/>
                    </svg>
                </div>
            </div>
            
        </div>
        <div class="footer__chat">
            <div class="input-msg">
                <form @keypress.enter="sendMsg">
                    <textarea v-model="msg" rows="1" placeholder="Write a reply.." @keydown.enter="preventNewLine"></textarea>
                </form>
            
                <span class="emoji">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.9997 3.23071C8.05057 3.23071 3.23047 8.05081 3.23047 13.9999C3.23047 19.9491 8.05057 24.7692 13.9997 24.7692C19.9488 24.7692 24.7689 19.9491 24.7689 13.9999C24.7689 8.05081 19.9488 3.23071 13.9997 3.23071ZM13.9997 22.6848C9.21 22.6848 5.31484 18.7896 5.31484 13.9999C5.31484 9.21024 9.21 5.31508 13.9997 5.31508C18.7894 5.31508 22.6846 9.21024 22.6846 13.9999C22.6846 18.7896 18.7894 22.6848 13.9997 22.6848ZM10.5258 13.3052C11.2944 13.3052 11.9153 12.6842 11.9153 11.9156C11.9153 11.147 11.2944 10.526 10.5258 10.526C9.75714 10.526 9.13617 11.147 9.13617 11.9156C9.13617 12.6842 9.75714 13.3052 10.5258 13.3052ZM17.4736 13.3052C18.2423 13.3052 18.8632 12.6842 18.8632 11.9156C18.8632 11.147 18.2423 10.526 17.4736 10.526C16.705 10.526 16.0841 11.147 16.0841 11.9156C16.0841 12.6842 16.705 13.3052 17.4736 13.3052ZM17.6473 16.4578C16.7441 17.5434 15.411 18.1687 13.9997 18.1687C12.5884 18.1687 11.2553 17.5477 10.3521 16.4578C9.98295 16.0148 9.3229 15.9584 8.88431 16.3231C8.44139 16.6922 8.38493 17.348 8.7497 17.7909C10.0524 19.3542 11.9674 20.2487 13.9997 20.2487C16.032 20.2487 17.947 19.3542 19.2497 17.7909C19.6188 17.348 19.558 16.6922 19.1151 16.3231C18.6765 15.9584 18.0164 16.0148 17.6473 16.4578Z" fill="#B3C2CB"/>
                    </svg>
                </span>
                <span class="send-btn" @click="sendMsg">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7071 1.29292C23.0976 1.68345 23.0976 2.31661 22.7071 2.70713L11.7071 13.7071C11.3166 14.0977 10.6834 14.0977 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L21.2929 1.29292C21.6834 0.902397 22.3166 0.902397 22.7071 1.29292Z" fill="#557EFB"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7071 1.29292C22.9787 1.56456 23.0708 1.96779 22.9439 2.33038L15.9439 22.3304C15.8084 22.7174 15.4504 22.9825 15.0408 22.9992C14.6311 23.0159 14.2527 22.7808 14.0862 22.4062L10.2424 13.7576L1.59387 9.91384C1.21919 9.74731 0.984122 9.36894 1.00084 8.95926C1.01755 8.54959 1.28265 8.19162 1.66965 8.05617L21.6697 1.05617C22.0322 0.929264 22.4355 1.02128 22.7071 1.29292ZM4.71108 9.11063L11.4061 12.0862C11.6324 12.1868 11.8133 12.3677 11.9138 12.5939L14.8894 19.289L20.37 3.63L4.71108 9.11063Z" fill="#557EFB"/>
                    </svg>
                </span>
            </div>
            <div class="emoji-sec"  v-if="false">
                <b-input-group prepend="@" class="mb-2 mr-sm-2 mb-sm-0">
                    <b-input placeholder="Search emoji"></b-input>
                </b-input-group>
                <h4>People</h4>
                <div class="emojis">
                    <span>&#128512;</span>
                </div>
            </div>
            <div class="secure-info" >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="encryption=!encryption">
                    <rect width="24" height="24" rx="4" :fill="encryptionFill"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.33301 12C6.96482 12 6.66634 12.2984 6.66634 12.6666V17.3333C6.66634 17.7015 6.96482 18 7.33301 18H16.6663C17.0345 18 17.333 17.7015 17.333 17.3333V12.6666C17.333 12.2984 17.0345 12 16.6663 12H7.33301ZM5.33301 12.6666C5.33301 11.5621 6.22844 10.6666 7.33301 10.6666H16.6663C17.7709 10.6666 18.6663 11.5621 18.6663 12.6666V17.3333C18.6663 18.4379 17.7709 19.3333 16.6663 19.3333H7.33301C6.22844 19.3333 5.33301 18.4379 5.33301 17.3333V12.6666Z" :fill="encryptionPathFill"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 5.99996C11.2928 5.99996 10.6145 6.28091 10.1144 6.78101C9.61428 7.28111 9.33333 7.95938 9.33333 8.66663V11.3333C9.33333 11.7015 9.03486 12 8.66667 12C8.29848 12 8 11.7015 8 11.3333V8.66663C8 7.60576 8.42143 6.58834 9.17157 5.8382C9.92172 5.08805 10.9391 4.66663 12 4.66663C13.0609 4.66663 14.0783 5.08805 14.8284 5.8382C15.5786 6.58834 16 7.60576 16 8.66663V11.3333C16 11.7015 15.7015 12 15.3333 12C14.9651 12 14.6667 11.7015 14.6667 11.3333V8.66663C14.6667 7.95938 14.3857 7.28111 13.8856 6.78101C13.3855 6.28091 12.7072 5.99996 12 5.99996Z" :fill="encryptionPathFill"/>
                </svg>
                <p>Secure Encrypted Messages</p>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99967 1.75004C4.10018 1.75004 1.74967 4.10055 1.74967 7.00004C1.74967 9.89954 4.10018 12.25 6.99967 12.25C9.89917 12.25 12.2497 9.89954 12.2497 7.00004C12.2497 4.10055 9.89917 1.75004 6.99967 1.75004ZM0.583008 7.00004C0.583008 3.45621 3.45585 0.583374 6.99967 0.583374C10.5435 0.583374 13.4163 3.45621 13.4163 7.00004C13.4163 10.5439 10.5435 13.4167 6.99967 13.4167C3.45585 13.4167 0.583008 10.5439 0.583008 7.00004Z" fill="#8D99A0"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99967 6.41671C7.32184 6.41671 7.58301 6.67787 7.58301 7.00004V9.33337C7.58301 9.65554 7.32184 9.91671 6.99967 9.91671C6.67751 9.91671 6.41634 9.65554 6.41634 9.33337V7.00004C6.41634 6.67787 6.67751 6.41671 6.99967 6.41671Z" fill="#8D99A0"/>encryptionPathFill
                    <path d="M7.58301 4.66671C7.58301 4.98887 7.32184 5.25004 6.99967 5.25004C6.67751 5.25004 6.41634 4.98887 6.41634 4.66671C6.41634 4.34454 6.67751 4.08337 6.99967 4.08337C7.32184 4.08337 7.58301 4.34454 7.58301 4.66671Z" fill="#8D99A0"/>
                </svg>
            </div>
        </div>
   </div>
  </b-sidebar>
</template>

<script>
//  import emojis from '@/assets/emojis.json'
export default {
    props: ['chat'],
    data(){
        return{
            encryption: true,
            chats: [
                {msg: 'Hello there! Let’s get started!', type: 0, time: '10:30 am', header: true, encryption: false, timestamp: 1594990282811},
                {msg: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque rhoncus urna non urna pharetra, ut blandit justo consequat. Sed nec augue sed sapien varius cursus eget ac tellus.', type: 0, time: '10:30 am', header: true, encryption: true, timestamp: 1594990282811},
                {msg: 'Hello there! Let’s get started!', type: 1, time: '10:31 am', header: true, encryption: false,timestamp: 1594990282811},
                {msg: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque rhoncus urna non urna .', type: 1, time: '10:30 am' , header: false, encryption: true, timestamp: 1594990282811},
                {msg: 'ntesque rhoncus urna non urna pharetra, ut blandit justo consequat. Sed nec augue sed sapien varius cursus eget ac tellus.', type: 0, time: '10:30 am', header: false, encryption: true, timestamp: 1594990282811},
                {msg: ' rhoncus urna non urna pharetra, ut blandit justo consequat. Sed nec augue sed sapien varius cursus eget ac tellus.', type: 1, time: '10:30 am', header: false, encryption: true, timestamp: 1594990282811},
            ],
            msg: ''
        }
    },
    computed: {
        encryptionFill(){
            if(this.encryption){
                return '#557EFB'
            }
            return 'none'
        },
        encryptionPathFill(){
            if(this.encryption){
                return '#fff'
            }
            return '#557EFB'
        },
    },
    mounted(){
        this.scrollToEnd()
    },
    methods: {
        closeMe(){
            this.$emit("closeMe")
        },
        preventNewLine(e){
            
            e.preventDefault();
            this.sendMsg();
            
        },
        sendMsg(){
            if(this.msg==""){
                return 
            }

           
            let time = new Date();
            
            var hours = time.getHours();
            var mins = time.getMinutes();
            var period= hours+mins>12?'PM': 'AM'
            hours = hours>12 ? hours%12: hours
            let lastChatHour = this.chats[this.chats.length-1].timestamp
            
            
            
            this.chats.push({
                msg: this.msg,
                type: 1,
                time: hours+":"+mins+" "+period,
                header: (Date.now()-3600000)>lastChatHour,
                encryption: this.encryption,
                timestamp: Date.now()
            })
             this.msg=""

           
           
             this.scrollToEnd();
                

        },
        scrollToEnd(){
            console.log("scroll to end");
            setTimeout(() => {
                 var chatbox = this.$el.querySelector('.body__chat')
            chatbox.scrollTop = chatbox.scrollHeight+20;
            console.log(chatbox.scrollHeight+20);
            }, 10);
             
            
        }
    }

}
</script>

<style lang="scss" scoped>
    .chat{
        padding: 60px 0;
        overflow: hidden;
        .header__chat{
            padding: 16px;
            border-bottom: 1px solid #DDDDDD;
            .close-icon{
                cursor: pointer;
            }
            img{
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 16px;
            }
            h3{
                font-family: 'Nunito', sans-serif;
                font-style: normal;
                font-weight: bold;
                font-size: 18px;
                line-height: 25px;
                color: #474D52;
                margin: 0;
            }

        }
        .body__chat{
            
            padding: 16px;
            // padding-bottom: 115px;
            height: calc(100vh - 290px);
            overflow-y: scroll;
            .msg-header{
                margin-bottom: 5px;
                h5,
                h4{
                    font-family: 'Nunito', sans-serif;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 19px;
                    color: #474D52;
                    margin: 0;
                }
                h5{
                    font-weight: normal;
                    color: #8D99A0;
                }
                &.send{
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: row-reverse;
                }
            }
            .msg{
                max-width: 85%;
                padding: 4px 0;
                margin-bottom: 4px;
                svg{
                    display: none;
                }
                p{
                    font-family: 'Nunito', sans-serif;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 19px;
                    color: #474D52;
                    margin: 0;
                }
                &.send{
                     margin-bottom: 8px;
                    position: relative;
                    margin-left: auto;
                   
                    padding: 4px 4px 4px 10px;
                    border-radius: 4px;
                    p{
                        text-align: right;
                    }
                    svg{
                        display: block;
                        position: absolute;
                        left: 4px;
                        bottom: 6px;

                    }
                    &.encryption{
                         background: rgba(85, 127, 251, 0.2);
                    }
                }
            }
            
        }
        .footer__chat{
            background-color: #fff;
            position: fixed;
            bottom: 80px;
            left: 0;
            right: 0;
            border-top: 1px solid #DDDDDD;
            padding-bottom: 10px;
           .input-msg{
                position: relative;
                textarea{
                    border: none;
                    padding:  15px 60px 10px 16px;
                    height: 52px;
                    font-family: 'Nunito', sans-serif;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 19px;
                    color: #474D52;
                    width: 100%;
                    overflow: hidden;
                    resize: none;
                }
                .send-btn,
                .emoji{
                    position: absolute;
                    top: 50%;
                    right: 40px;
                    transform: translateY(-64%);
                    cursor: pointer;
                }
                .send-btn{
                    right: 10px
                }
           }
           .emoji-sec{
                width: 300px;
                height: 196px;
                h4{
                    font-family: 'Nunito', sans-serif;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 19px;
                    color: #474D52;

                }
                .emojis{
                    overflow-y: scroll;
                }
           }
           .secure-info{
               background-color: #fff;
               display: flex;
               align-items: center;
               padding-left: 16px;
               svg{
                   cursor: pointer;
               }
               p{
                margin: 0 5px ;
                font-family: 'Nunito', sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                color: #8D99A0;
               }
           }
           
        }

    }

    
@media (max-width: 560px){
    .chat{
        padding: 0;
    }
    .b-sidebar-outer{
        z-index: 8 !important;
    }
    .chat .body__chat{
        height: calc( 100vh - 100px);
    }
    .chat .footer__chat{
        bottom: 0;
    }
    .chat .header__chat{
        position: fixed;
        left: 0;
        right: 0;
        background-color: #fff !important;
        z-index: 2;
    }
    ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    background: #FF0000;
}
}
</style>